<script>
  export let reviewImages
  export let handleClick
  const imagesLimit = 3
  const addOverlay = index => {
    if (reviewImages.length > imagesLimit && index === imagesLimit - 1) {
      return true
    }
    return false
  }

  const hideImage = index => {
    if (index > imagesLimit - 1) {
      return true
    }
  }
</script>

<style>
  .review-images {
    padding-top: 20px;
  }

  .image-box {
    position: relative;
    overflow: hidden;
    display: inline-flex;
    align-items: center;
    text-align: center;
    width: 64px;
    height: 64px;
    border: 1px solid #edeff0;
    border-radius: 4px;
    margin-right: 14px;
    cursor: pointer;
  }

  .image-box img {
    width: 100%;
    height: 100%;
  }

  .image-box.more::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    background: #34495e;
  }

  .image-box.more p {
    font-size: 16px;
    position: absolute;
    z-index: 2;
    display: inline-block;
    color: #fff;
    margin: auto;
    left: 0;
    right: 0;
  }

  .hide-image {
    display: none !important;
    pointer-events: none;
  }
</style>

<div class="$style.review-images">
  {#each reviewImages as image, i}
    {#if addOverlay(i)}
      <div
        class="$style.image-box more"
        class:hide-image={hideImage(i)}
        on:click={handleClick}>
        <p>+{reviewImages.length - imagesLimit}</p>
        <img src={image.standard} alt="review media" />
      </div>
    {:else}
      <div
        class="$style.image-box"
        class:hide-image={hideImage(i)}
        on:click={handleClick}>
        <img src={image.standard} alt="review media" />
      </div>
    {/if}
  {/each}
</div>
